import WithdrawFunds from './WithdrawFunds';
export default WithdrawFunds;
